import { CURRENCY_MINOR_UNITS } from './enums.js';
export function money(amountMinor, currency) {
    if (!Number.isInteger(amountMinor)) {
        throw new TypeError(`Money must be an integer in minor units, received ${amountMinor}`);
    }
    return { amountMinor, currency };
}
/** 1234.56 USD -> 123456 minor units. Rounds half away from zero. */
export function toMinor(major, currency) {
    const factor = CURRENCY_MINOR_UNITS[currency];
    return Math.round(major * factor);
}
export function toMajor(amountMinor, currency) {
    return amountMinor / CURRENCY_MINOR_UNITS[currency];
}
/** Locale-aware display. Arabic uses Eastern Arabic numerals via the locale. */
export function formatMoney(m, locale = 'en') {
    return new Intl.NumberFormat(locale === 'ar' ? 'ar-LB' : 'en-US', {
        style: 'currency',
        currency: m.currency,
        minimumFractionDigits: CURRENCY_MINOR_UNITS[m.currency] === 1 ? 0 : 2,
    }).format(toMajor(m.amountMinor, m.currency));
}
/**
 * Convert to USD minor units using a rate expressed as
 * "how many USD is one unit of `from`", scaled by 1e6 to stay integral.
 */
export function convertToUsdMinor(m, rateToUsdScaled) {
    if (m.currency === 'USD')
        return m.amountMinor;
    const major = toMajor(m.amountMinor, m.currency);
    const usdMajor = (major * rateToUsdScaled) / 1_000_000;
    return Math.round(usdMajor * CURRENCY_MINOR_UNITS.USD);
}
/**
 * Margin in basis points (1% = 100bp), or null when there was no revenue to
 * divide by — "no margin" and "no sales" are different facts and must not
 * both render as 0%.
 *
 * Integer basis points rather than a float percentage so the screen and the
 * Excel export cannot round it differently and disagree. Both arguments must
 * already be in the same currency's minor units.
 */
export function marginBp(revenueMinor, costMinor) {
    if (revenueMinor === 0)
        return null;
    return Math.round(((revenueMinor - costMinor) / revenueMinor) * 10_000);
}
//# sourceMappingURL=money.js.map